import React from 'react';
import styled from 'styled-components';

const Radio = ({ title, options, name }) => {
  return (
    <Root>
      <Title>{title}</Title>
      {options.map(option => (
        <RadioButton key={option}>
          <input type="radio" id={option} value={option} name={name} required />
          <span htmlFor={option}>{option}</span>
        </RadioButton>
      ))}
    </Root>
  );
};

const Root = styled.div`
  margin-bottom: 20px;
  font-family: 'DINOT';
`;

const Title = styled.p`
  opacity: 0.8;
  font-family: 'DINOT';
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0;
  margin-bottom: 7px;
`;

const RadioButton = styled.div`
  display: flex;
  align-items: center;
  font-family: 'DINOT';
  input[type='radio'] {
    appearance: none;
    outline: none;
    opacity: 0.8;
    border-radius: 50%;
    border: 1px solid #FFFFFF;
    width: 15px;
    height: 15px;
    font-family: 'DINOT';
    position: relative;
    &:checked:after {
      content: '';
      position: absolute;
      top: 3px;
      left: 3px;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #FFFFFF;
    }
  }
  > span {
    padding-left: 10px;
    margin-bottom: 7px;
    opacity: 0.8;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    font-family: 'DINOT';
  }
`;

export default Radio;



// WEBPACK FOOTER //
// ./src/pages/Register/elements/Form/elements/Radio.js